import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { Route, Router, RouterModule, RouterOutlet } from '@angular/router';
import { SharedService } from '../Shared/services/shared.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { RestaurantUser } from '../Shared/interfaces/loginUserRes.interface';
import { ApiResponce } from '../Shared/interfaces/apiResponce.interface';
import { MenuCategory } from '../Shared/interfaces/restaurantMenu.interface';
import { discount } from '../Shared/interfaces/discounts.interface';
import { TrigerToastService } from '../Shared/services/triger-toast.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
@Component({
  selector: 'app-layout',
  standalone: true,
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  imports: [
    HeaderComponent,
    RouterModule,
    RouterOutlet,
    DialogModule,
    ButtonModule,
    ReactiveFormsModule,
    InputTextModule,
    InputTextareaModule,
  ],
})
export class LayoutComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  localStorageData: any;
  loginUser: RestaurantUser | null = null;
  restaurantMenu: MenuCategory[] = [];
  userRoleData!: RestaurantUser;
  discountsList: discount[] = [];

  constructor(
    private sharedS: SharedService,
    private toastS: TrigerToastService,
    private route: Router,
    private fb: FormBuilder
  ) {}
  ngOnInit(): void {
    this.getLocalStorageData();
    this.getLocalStorage();
    // console.log("Layout Comp...");
    // this.routeGuardforKitchenScreen();
  }

  getLocalStorageData() {
    this.sharedS
      .getData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if (data && JSON.stringify(data) != '{}') {
          this.localStorageData = data;
          this.restaurantMenu =
            data && data.restaurantMenu ? data.restaurantMenu : [];
          this.loginUser =
            this.localStorageData && this.localStorageData.user
              ? this.localStorageData.user
              : null;
          if (
            this.localStorageData &&
            this.restaurantMenu &&
            this.restaurantMenu.length < 1
          ) {
            //  this.getBranchMenu();
            //  this.getBankListofBranch();
            //  this.getPaymentTypeList();
            //  this.getOrderStatus();
            //  this.getDiscounts();
          }
        }
      });
  }

  getBranchMenu() {
    this.sharedS.sendGetRequest('get_restaurant_branch_menu').subscribe({
      next: (res: ApiResponce) => {
        if (res.Success) {
          this.sharedS.insertData({ key: 'restaurantMenu', val: res.Data });
        } else {
        }
      },
      error: (err: any) => {},
    });
  }

  getLocalStorage() {
    this.sharedS.getData().subscribe((val: any) => {
      this.userRoleData = val.user;
    });
  }

  routeGuardforKitchenScreen() {
    console.log(this.route.url);
    if (
      this.loginUser?.rolename ==
        this.sharedS.POSRoleName.pos_kitchen_manager &&
      this.route.url == '/'
    ) {
      this.route.navigate(['/kitchen-status']);
    } else if (
      this.loginUser?.rolename == this.sharedS.POSRoleName.pos_kitchen ||
      (this.sharedS.POSRoleName.pos_dispatcher && this.route.url == '/')
    ) {
      this.route.navigate(['/separate-kitchen']);
    } else {
      // this.route.navigate(['']);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
